module.exports = __webpack_public_path__ + "img/ssyx_34.a2b1c55a.jpg";